<template>
  <PageContainer :title="title">
    <div v-if="!loaded" class="d-flex justify-content-center">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
      </component>
    </div>

    <Box v-else class="usuario-container" space="medium">
      <div v-if="mode === 'edit'" class="">
        <Button type="button" @handle:click="toUsersList" text="Voltar" :fill="false" color="primary"
          :disabled="loading">
        </Button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="inputs">
          <div class="inputs-row">
            <Input :modelValue="nome" @update:modelValue="$event => (this.nome = $event)" legend="Nome"
              placeholder="Nome" :disabled="loading" />

            <Input class="input-cpf" mask="###.###.###-##" :modelValue="cpf"
              @update:modelValue="$event => (this.cpf = $event)" legend="CPF" placeholder="CPF" :disabled="loading" />
          </div>

          <div class="inputs-row">
            <Input type="email" :modelValue="email" @update:modelValue="$event => (this.email = $event)" legend="Email"
              placeholder="Email" :disabled="loading" />

            <Input class="input-telefone" mask="(##) #####-####" :modelValue="telefone"
              @update:modelValue="$event => (this.telefone = $event)" legend="Telefone/Celular"
              placeholder="(00) 00000-0000" :disabled="loading" />

            <SingleDate class="input-nascimento" legend="Data de Nascimento" :modelValue="nascimento"
              @update:modelValue="$event => (this.nascimento = $event)" />
          </div>

          <div class="inputs-row">
            <Select :options="funcoes" :modelValue="funcao" @update:modelValue="$event => (this.funcao = $event)"
              legend="Função" placeholder="Função" :disabled="loading" data-testid="select-funcao-usuario" />

            <Input class="input-password" type="password" :modelValue="password"
              @update:modelValue="$event => (this.password = $event)" legend="Senha" placeholder="Senha"
              :disabled="loading" />

            <Input class="input-password" type="password" :modelValue="confirmPassword"
              @update:modelValue="$event => (this.confirmPassword = $event)" legend="Confirmar Senha"
              placeholder="Confirmar Senha" :disabled="loading" />
          </div>

          <div class="inputs-row">
            <Select :options="autoescolas" :modelValue="schema" @update:modelValue="$event => (this.schema = $event)"
              legend="Auto escola" placeholder="Auto escola" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Salvar" color="primary" :disabled="loading">
            <ContentSaveOutline :size="18" />
          </Button>
        </div>
      </form>
    </Box>

    <!-- <vuestic-modal ref="addCfcToUser" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">Adicionar Usuário em outro CFC</div>
      <addCfc></addCfc>
    </vuestic-modal> -->
  </PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import PageContainer from '../core/PageContainer'
import Box from '../core/Box'
import Button from '../core/Button'
import Input from '../core/Input'
import SingleDate from '../core/SingleDate'
import Select from '../core/Select'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import ContentSaveOutline from 'icons/ContentSaveOutline'
import ArrowLeft from 'icons/ArrowLeft'

// import AddCfc from './modal/addCfc'

export default {
  name: 'FormUsuario',
  components: {
    ...spinners,
    CloseCircleOutline,
    ContentSaveOutline,
    ArrowLeft,

    PageContainer,
    Box,
    Button,
    Input,
    SingleDate,
    Select,
  },
  data () {
    return {
      mode: 'add',
      title: 'Novo Usuário',
      nome: '',
      cpf: '',
      email: '',
      telefone: '',
      nascimento: '',
      funcao: '',
      password: '',
      confirmPassword: '',
      schema: '',
      funcoes: [],
      autoescolas: [],
      loading: false,
      loaded: false,
    }
  },
  async created () {
    if (this.$route.params.idUsuario) {
      this.mode = 'edit'
      this.title = 'Editar Usuário'
    }

    this.clearInputs()

    await Promise.all([
      this.getFuncoes(),
      this.getSchema(),
    ])

    if (this.mode === 'edit') {
      await this.getUser(this.$route.params.idUsuario)
    }

    this.loaded = true
  },
  methods: {
    async getUser (id) {
      await this.$http.get(`${urlApi}/usuarios/${id}`)
        .then(response => {
          const dados = response.body.dados

          this.nome = dados.nome || ''
          this.cpf = dados.cpf || ''
          this.email = dados.email || ''
          this.telefone = dados.telefone || ''
          this.nascimento = dados.data_nascimento || ''
          this.funcao = dados.id_funcao_usuario || ''
          this.schema = dados.schema || ''
        })
        .catch(err => {
          this.toast(err.body.mensagem)
        })
    },
    async getFuncoes () {
      await this.$http.get(`${urlApi}/usuarios/funcoes`)
        .then(response => {
          const dados = response.body

          this.funcoes = dados.map(funcao => ({ value: funcao.id_funcao_usuario, text: funcao.funcao_usuario }))
        })
        .catch(err => {
          this.toast('Erro ao buscar as funções do usuário.')
        })
    },
    async getSchema () {
      if (localStorage.id_role == 2) {
        return await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola`)
          .then(response => {
            this.autoescolas = response.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
          })
          .catch(err => {
            this.toast('Erro ao buscar autoescolas.')
          })
          .finally(() => {
            this.loadingCfc = false
          })
      }

      return await this.$http.get(`${urlApi}/cfc/schema/${localStorage.cfc}`)
        .then(response => {
          const dados = response.body
          const schema = dados.toLowerCase().replace(/\s+/g, '')

          this.autoescolas = [
            { value: schema, text: dados }
          ]

          this.schema = schema
        })
        .catch(err => {
          this.toast('Erro ao buscar a auto escola.')
        })
    },
    async handleSubmit () {
      if (this.validateInputs()) {
        this.loading = true

        const params = {
          nome: this.nome,
          cpf: this.cpf,
          email: this.email,
          telefone: this.telefone,
          data_nascimento: this.nascimento,
          id_funcao_usuario: this.funcao,
          password: this.password,
          repeat_password: this.confirmPassword,
          schema: this.schema,
        }

        if (this.mode === 'add') {
          await this.$http.post(`${urlApi}/usuarios`, params)
            .then(async response => {
              this.toast('Usuário cadastrado com sucesso! Aguarde, encaminhando para listagem de usuários...')
              await this.sleep(1000)
              this.toUsersList()
            })
            .catch(err => {
              this.toast('Erro ao cadastrar o usuário!')
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          await this.$http.patch(`${urlApi}/usuarios/${this.$route.params.idUsuario}`, params)
            .then(async response => {
              this.toast('Usuário atualizado com sucesso! Aguarde, encaminhando para listagem de usuários...')
              await this.sleep(1000)
              this.toUsersList()
            })
            .catch(err => {
              this.toast('Erro ao editar o usuário!')
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    validateInputs () {
      if (!this.nome || !this.cpf || !this.email || !this.telefone || !this.nascimento || !this.funcao || !this.password || !this.confirmPassword || !this.schema) {
        this.toast('Preencha todos os campos.')

        return false
      }

      if (this.password !== this.confirmPassword) {
        this.toast('As senhas não conferem.')

        return false
      }

      return true
    },
    toUsersList () {
      this.$router.push({ name: 'listagem-usuarios' })
    },
    clearInputs () {
      this.nome = ''
      this.cpf = ''
      this.email = ''
      this.telefone = ''
      this.nascimento = ''
      this.funcao = ''
      this.password = ''
      this.confirmPassword = ''
      this.schema = ''
    },
    toast (text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    sleep (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
  }
}
</script>

<style lang="scss" scoped>
.usuario-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        div {
          flex: 1;
        }

        .input-cpf {
          max-width: 25.75rem;
        }

        .input-telefone {
          max-width: 21.125rem;
        }

        .input-nascimento {
          max-width: 14.1875rem;
        }

        .input-password {
          max-width: 15.84375rem;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .buttons-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
  }
}
</style>
